"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bormio": {
    "060989bd": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "skipSearch": false
    }],
    "buglio": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c2132f9": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "skipSearch": false
    }],
    "combo": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05aa30e8": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "skipSearch": false
    }],
    "dossiglio": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "667f4997": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "skipSearch": false
    }],
    "dossoruina": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "829766bb": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "skipSearch": false
    }],
    "maggiore": [{
      "hkey": "c41adbe0",
      "slug": "bormio",
      "name": "Bormio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;